"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4503],{

/***/ 34503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ ContainerToken; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/use-intl.esm3.js + 18 modules
var use_intl_esm3 = __webpack_require__(72439);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/auth-decorator/index.tsx
var auth_decorator = __webpack_require__(36013);
// EXTERNAL MODULE: ./src/lib/versum/index.ts + 11 modules
var versum = __webpack_require__(44980);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/button-like/styles.ts



var _obj;
var Container = (0,stitches/* styled */.zo)("div", (_obj = {}, (0,_define_property/* default */.Z)(_obj, "& ".concat(index_es/* Button */.zx), {
    display: "flex",
    alignItems: "center",
    padding: "$space$4 0",
    backgroundColor: "transparent",
    border: "none",
    i: {
        fontSize: 16,
        marginRight: 4,
        color: "$secondaryFill"
    }
}), (0,_define_property/* default */.Z)(_obj, "variants", {
    selected: {
        true: (0,_define_property/* default */.Z)({}, "& ".concat(index_es/* Button */.zx), {
            i: {
                color: "$primaryFill"
            }
        })
    }
}), _obj));

;// CONCATENATED MODULE: ./src/components/button-like/index.tsx



/* eslint-disable react-hooks/exhaustive-deps */ 






var ButtonLike = function(param) {
    var tokenId = param.tokenId;
    var ref;
    var t = (0,use_intl_esm3/* default */.Z)("common");
    var ref1 = (0,react.useState)(), isSelected = ref1[0], setIsSelected = ref1[1];
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    });
    var userid = (ref = auth.user) === null || ref === void 0 ? void 0 : ref.id;
    (0,react.useEffect)(function() {
        var load = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var result, nextSelected;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!userid) {
                                _ctx.next = 6;
                                break;
                            }
                            _ctx.next = 3;
                            return (0,versum/* UserLikesToken */.kS)(userid, tokenId);
                        case 3:
                            result = _ctx.sent;
                            nextSelected = result.user_likes_token.length > 0;
                            setIsSelected(nextSelected);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function load() {
                return _ref.apply(this, arguments);
            };
        }();
        load();
    }, [
        userid
    ]);
    var handleClick = function() {
        setIsSelected(!isSelected);
        if (!isSelected) {
            (0,versum/* LikeToken */.LH)(tokenId);
        } else {
            (0,versum/* UnlikeToken */.XM)(tokenId);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        selected: isSelected,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
            onClick: handleClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Button */.zx, {
                variant: "basic",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: "favorite"
                    }),
                    isSelected ? t("unlike") : t("like")
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/state/modals/index.ts
var modals = __webpack_require__(68525);
;// CONCATENATED MODULE: ./src/components/button-save/styles.ts



var styles_obj;
var styles_Container = (0,stitches/* styled */.zo)("div", (styles_obj = {}, (0,_define_property/* default */.Z)(styles_obj, "& ".concat(index_es/* Button */.zx), {
    display: "flex",
    alignItems: "center",
    padding: "$space$4 0",
    backgroundColor: "transparent",
    border: "none",
    i: {
        fontSize: 16,
        marginRight: 4,
        color: "$secondaryFill"
    }
}), (0,_define_property/* default */.Z)(styles_obj, "variants", {
    selected: {
        true: (0,_define_property/* default */.Z)({}, "& ".concat(index_es/* Button */.zx), {
            i: {
                color: "$red"
            }
        })
    }
}), styles_obj));

;// CONCATENATED MODULE: ./src/components/button-save/index.tsx







var ButtonSave = function(param) {
    var tokenId = param.tokenId;
    var ref;
    var t = (0,use_intl_esm3/* default */.Z)("common");
    var dispatch = (0,es/* useDispatch */.I0)();
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    });
    var viewer = (ref = auth.user) === null || ref === void 0 ? void 0 : ref.id;
    var handleClick = function() {
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "token-save",
                tokenId: tokenId,
                viewer: viewer
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
            onClick: handleClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Button */.zx, {
                variant: "basic",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: "bookmark_border"
                    }),
                    t("save")
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/creators/index.tsx + 1 modules
var components_creators = __webpack_require__(68806);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/components/avatar/index.tsx + 1 modules
var avatar = __webpack_require__(11422);
// EXTERNAL MODULE: ./src/components/thumbnail-board/index.tsx + 1 modules
var thumbnail_board = __webpack_require__(13707);
// EXTERNAL MODULE: ./src/utils/token.ts
var utils_token = __webpack_require__(56373);
// EXTERNAL MODULE: ./src/utils/use-media.ts
var use_media = __webpack_require__(46873);
// EXTERNAL MODULE: ./src/utils/user.ts
var utils_user = __webpack_require__(12857);
;// CONCATENATED MODULE: ./src/components/curated-on/index.tsx










var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
var CuratedOn = function(param) {
    var id = param.id;
    var router = (0,next_router.useRouter)();
    var total = (0,use_media/* useMedia */.G)([
        "(min-width: 1440px)",
        "(min-width: 640px)"
    ], [
        6,
        4
    ], 2);
    var data = (0,dist/* default */.ZP)(function() {
        return "/api/public/boards/token/".concat(id);
    }, fetcher, {
        revalidateOnFocus: false
    }).data;
    if ((data === null || data === void 0 ? void 0 : data.token_lists.length) > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                    as: "h6",
                    children: "Curated on"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        display: "grid",
                        gridTemplateColumns: "repeat(".concat(total, ", minmax(0, 1fr))"),
                        gap: "0 0",
                        padding: "0 0 $space$2 0",
                        border: "1px solid transparent",
                        "@bp1": {
                            border: "none",
                            gap: "$2 $2"
                        }
                    },
                    children: data === null || data === void 0 ? void 0 : data.token_lists.map(function(board, index) {
                        var screenName = (0,utils_user/* getScreenName */.GG)(board.user.verified_on_chain, board.user.screen_name, board.user.id, board.user.name);
                        if (index < total) {
                            var images = board.tokens.map(function(param) {
                                var token = param.token;
                                return (0,utils_token/* getSmallestImageBoardPreview */._U)(token);
                            }).map(function(e) {
                                return e.src;
                            });
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                css: {
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/board/".concat(board.id),
                                        locale: router.locale,
                                        prefetch: false,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(thumbnail_board/* ThumbnailBoard */.V, {
                                                cover: board.cover_uri,
                                                images: images
                                            }, board.id)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                        css: {
                                            flexDirection: "column",
                                            padding: "$space$4"
                                        },
                                        children: [
                                            board.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                                unset: true,
                                                css: {
                                                    textAlign: "left"
                                                },
                                                ellipsis: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: board.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/user/".concat(board.user.id, "/created"),
                                                locale: router.locale,
                                                prefetch: false,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Button */.zx, {
                                                    as: "a",
                                                    variant: "basic",
                                                    css: {
                                                        fontSize: 14,
                                                        lineHeight: 1,
                                                        display: "flex"
                                                    },
                                                    children: [
                                                        screenName,
                                                        board.user.verified_on_chain && /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Verified */.z, {
                                                            size: 10,
                                                            secondary: true
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, "curated-on-".concat(board.id));
                        }
                        return null;
                    })
                })
            ]
        });
    }
    return null;
};

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-tabs/dist/index.module.js
var index_module = __webpack_require__(36888);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/table-components/index.ts + 14 modules
var table_components = __webpack_require__(64944);
;// CONCATENATED MODULE: ./src/components/tables/token-collectors/index.tsx





var settings = [
    {
        key: "collected",
        label: "Source",
        Component: function(param) {
            var collected = param.collected;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* TextComponent */.Tk, {
                value: collected ? "Purchased" : "Received"
            });
        }
    },
    {
        key: "collectorScreenName",
        label: "Collector",
        Component: function(param) {
            var collectorScreenName = param.collectorScreenName, holder = param.holder, isYou = param.isYou, isCreator = param.isCreator;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* UserComponent */.A2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, holder.user[0].user), {
                parsedScreenName: collectorScreenName,
                address: holder.address,
                isYou: isYou,
                isCreator: isCreator
            }));
        }
    },
    {
        key: "amount",
        label: "Quantity",
        Component: function(param) {
            var amount = param.amount;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* TextComponent */.Tk, {
                value: amount
            });
        }
    }, 
];
var TableTokenCollectors = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Table */.iA, {
        settings: settings,
        data: data,
        canSelect: false
    });
};

;// CONCATENATED MODULE: ./src/components/item-tabs/collectors.tsx



/* eslint-disable camelcase */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable react/no-unescaped-entities */ 



function Collectors() {
    var ref;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.token;
    }), holders = ref1.holders, creators = ref1.creators;
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    });
    var viewer = (ref = auth.user) === null || ref === void 0 ? void 0 : ref.id;
    // holders list decorated with `isCreator` and `isYou`.
    // it also allows for table sorting to work because its `key` based.
    // so sorting by `verified` is possible instead of sorting by holder.user[0].user.verified_on_chain
    var parsed = holders.map(function(user) {
        var holder = user.holder;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
            collectorScreenName: (0,utils_user/* getScreenName */.GG)(holder.user[0].user.verified_on_chain, holder.user[0].user.screen_name, holder.user[0].user.id, holder.user[0].user.name),
            isCreator: creators.filter(function(e) {
                return e.wallet.address === holder.address;
            }).length > 0,
            isYou: holder.address === viewer
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
        css: {
            flexDirection: "column",
            minHeight: 256
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableTokenCollectors, {
            data: parsed
        })
    });
}

// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
;// CONCATENATED MODULE: ./src/components/tables/token-history/index.tsx






var token_history_settings = [
    {
        key: "timestamp",
        label: "Date",
        Component: function(param) {
            var timestamp = param.timestamp;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* DateComponent */.Id, {
                timestamp: timestamp
            });
        }
    },
    {
        key: "sellerScreenName",
        label: "Seller",
        Component: function(param) {
            var sellerScreenName = param.sellerScreenName, seller = param.seller, sellerIsYou = param.sellerIsYou, sellerIsCreator = param.sellerIsCreator;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* UserComponent */.A2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, seller.user[0].user), {
                parsedScreenName: sellerScreenName,
                address: seller.address,
                isYou: sellerIsYou,
                isCreator: sellerIsCreator
            }));
        }
    },
    {
        key: "buyerScreenName",
        label: "Buyer",
        Component: function(param) {
            var buyerScreenName = param.buyerScreenName, buyer = param.buyer, buyerIsYou = param.buyerIsYou, buyerIsCreator = param.buyerIsCreator;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* UserComponent */.A2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buyer.user[0].user), {
                parsedScreenName: buyerScreenName,
                address: buyer.address,
                isYou: buyerIsYou,
                isCreator: buyerIsCreator
            }));
        }
    },
    {
        key: "amount_collected",
        label: "Quantity",
        Component: function(param) {
            var amount_collected = param.amount_collected;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* TextComponent */.Tk, {
                value: amount_collected
            });
        }
    },
    {
        key: "price",
        label: "Price",
        Component: function(param) {
            var price = param.price;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* PriceComponent */.C9, {
                value: (0,format/* MutToTez */.QO)(price)
            });
        }
    }, 
];
var TableTokenHistory = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Table */.iA, {
        settings: token_history_settings,
        data: data,
        canSelect: false
    });
};

;// CONCATENATED MODULE: ./src/components/item-tabs/history.tsx







var History = function() {
    var ref;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.token;
    }), history = ref1.history, creators = ref1.creators;
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    });
    var viewer = (ref = auth.user) === null || ref === void 0 ? void 0 : ref.id;
    var parsed = history.map(function(user) {
        var buyer = user.buyer, seller = user.seller;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
            // buyer
            buyerScreenName: (0,utils_user/* getScreenName */.GG)(buyer.user[0].user.verified_on_chain, buyer.user[0].user.screen_name, buyer.user[0].user.id, buyer.user[0].user.name),
            buyerIsCreator: creators.filter(function(e) {
                return e.wallet.address === buyer.address;
            }).length > 0,
            buyerIsYou: buyer.address === viewer,
            // seller
            sellerScreenName: (0,utils_user/* getScreenName */.GG)(seller.user[0].user.verified_on_chain, seller.user[0].user.screen_name, seller.user[0].user.id, seller.user[0].user.name),
            sellerIsCreator: creators.filter(function(e) {
                return e.wallet.address === seller.address;
            }).length > 0,
            sellerIsYou: seller.address === viewer
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
        css: {
            flexDirection: "column",
            minHeight: 256
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableTokenHistory, {
                data: parsed
            }),
             false && /*#__PURE__*/ 0
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/ipfs.ts
var ipfs = __webpack_require__(80125);
;// CONCATENATED MODULE: ./src/components/item-tabs/info.tsx






var DataBlock = function(param) {
    var label = param.label, children = param.children, reversed = param.reversed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
        css: {
            marginBottom: "$space$2",
            flexDirection: "column"
        },
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                css: {
                    color: reversed ? "$secondaryFill" : "$primaryFill",
                    fontWeight: 700,
                    marginBottom: 8
                },
                children: label
            }),
            children
        ]
    });
};
var Info = function(param) {
    var token = param.token;
    var t = (0,use_intl_esm3/* default */.Z)("token");
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var contract = token.contract;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
        css: {
            flexDirection: "column",
            minHeight: 256
        },
        children: [
            token.attributes && token.attributes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DataBlock, {
                label: "Attributes",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        flexFlow: "row wrap",
                        "&>*": {
                            marginRight: 8,
                            marginBottom: 8
                        }
                    },
                    children: token.attributes.map(function(param, index) {
                        var attribute = param.attribute, value = param.value;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/collections/".concat(contract.name, "/?").concat(attribute.id, "=").concat(value.id),
                            locale: locale,
                            prefetch: false,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                as: "a",
                                css: {
                                    backgroundColor: "$secondaryBackground",
                                    borderRadius: 5,
                                    padding: "$space$4",
                                    color: "$secondaryFill",
                                    fontSize: 12
                                },
                                children: [
                                    attribute.name,
                                    "\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                        css: {
                                            color: "$primaryFill",
                                            fontWeight: 700,
                                            fontSize: 12
                                        },
                                        children: value.name
                                    })
                                ]
                            })
                        }, "token".concat(token.token_id, "-").concat(index));
                    })
                })
            }),
            token.contract.wallet && /*#__PURE__*/ (0,jsx_runtime.jsx)(DataBlock, {
                label: t("contract"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    as: "a",
                    variant: "basic",
                    href: "https://tzkt.io/".concat(token.contract.wallet.address, "/operations/"),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    shrink: true,
                    css: {
                        fontSize: 16
                    },
                    children: token.contract.wallet.address
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataBlock, {
                label: t("symbol"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                    unset: true,
                    css: {
                        color: "$secondaryFill"
                    },
                    children: token.symbol
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataBlock, {
                label: t("max-wallet"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                    unset: true,
                    css: {
                        color: "$secondaryFill"
                    },
                    children: token.max_per_address > 0 ? token.max_per_address : "Unlimited"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataBlock, {
                label: t("royalties"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                    unset: true,
                    css: {
                        color: "$secondaryFill"
                    },
                    children: [
                        token.royalties,
                        "%"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataBlock, {
                label: t("splits"),
                children: token.splits.sort(function(param, param1) {
                    var a = param.dividend, b = param1.dividend;
                    return b - a;
                }).map(function(split) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                css: {
                                    margin: "0 $space$3 0 $space$3",
                                    width: 16,
                                    height: 16,
                                    borderLeft: "2px solid $primaryBorder",
                                    borderBottom: "2px solid $primaryBorder",
                                    borderBottomLeftRadius: 6
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                css: {
                                    color: "$primaryFill",
                                    fontSize: 14,
                                    fontWeight: 700
                                },
                                children: [
                                    split.dividend,
                                    "%\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                as: "a",
                                variant: "basic",
                                href: "https://tzkt.io/".concat(split.wallet.address, "/operations/"),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                shrink: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                    unset: true,
                                    css: {
                                        fontSize: 14,
                                        color: "inherit"
                                    },
                                    ellipsis: true,
                                    children: split.wallet.address
                                })
                            })
                        ]
                    }, split.wallet.address);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataBlock, {
                label: "IPFS",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                    css: {
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            as: "a",
                            variant: "basic",
                            href: (0,ipfs/* getURLFromIPFSURI */.vR)(token.metadata_uri),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            shrink: true,
                            css: {
                                fontSize: 16
                            },
                            children: "Metadata"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            as: "a",
                            variant: "basic",
                            href: (0,ipfs/* getURLFromIPFSURI */.vR)(token.artifact_uri),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            shrink: true,
                            css: {
                                fontSize: 16
                            },
                            children: "Artifact"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/tables/token-auctions/index.tsx






var token_auctions_settings = [
    // {
    //   key: 'status',
    //   label: 'Status',
    //   Component: ({ status }: Record<string, any>) => <TextComponent value={status} />,
    // },
    {
        key: "sellerScreenName",
        label: "Seller",
        Component: function(param) {
            var sellerScreenName = param.sellerScreenName, seller = param.seller, sellerIsYou = param.sellerIsYou, sellerIsCreator = param.sellerIsCreator;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* UserComponent */.A2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, seller.user[0].user), {
                parsedScreenName: sellerScreenName,
                address: seller.address,
                isYou: sellerIsYou,
                isCreator: sellerIsCreator
            }));
        }
    },
    {
        key: "start_time",
        label: "Auction start",
        Component: function(param) {
            var start_time = param.start_time;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* DateComponent */.Id, {
                timestamp: start_time
            });
        }
    },
    {
        key: "end_time",
        label: "Auction end",
        Component: function(param) {
            var end_time = param.end_time;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* DateComponent */.Id, {
                timestamp: end_time
            });
        }
    },
    {
        key: "current_bidder",
        label: "Highest Bidder",
        Component: function(param) {
            var bidderScreenName = param.bidderScreenName, current_bidder = param.current_bidder, bidderIsYou = param.bidderIsYou, bidderIsCreator = param.bidderIsCreator;
            if (current_bidder) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* UserComponent */.A2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, current_bidder.user[0].user), {
                    parsedScreenName: bidderScreenName,
                    address: current_bidder.user[0].user.id,
                    isYou: bidderIsYou,
                    isCreator: bidderIsCreator
                }));
            }
            return null;
        }
    },
    {
        key: "current_bid",
        label: "Highest Bid",
        Component: function(param) {
            var current_bid = param.current_bid, current_bidder = param.current_bidder;
            var hasBidder = current_bidder === null || current_bidder === void 0 ? void 0 : current_bidder.user[0].user;
            return hasBidder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* PriceComponent */.C9, {
                value: (0,format/* MutToTez */.QO)(current_bid)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* TextComponent */.Tk, {
                value: "No bids"
            });
        }
    },
    {
        key: "actions",
        label: "Actions",
        Component: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* ActionAuctionsComponent */.Y_, (0,_object_spread/* default */.Z)({}, props));
        }
    }, 
];
var TableTokenAuctions = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Table */.iA, {
        settings: token_auctions_settings,
        data: data
    });
};

;// CONCATENATED MODULE: ./src/components/tables/token-offers/index.tsx






var token_offers_settings = [
    {
        key: "buyerScreenName",
        label: "From",
        Component: function(param) {
            var buyerScreenName = param.buyerScreenName, buyer = param.buyer, buyerIsYou = param.buyerIsYou, buyerIsCreator = param.buyerIsCreator;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* UserComponent */.A2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buyer.user[0].user), {
                parsedScreenName: buyerScreenName,
                address: buyer.address,
                isYou: buyerIsYou,
                isCreator: buyerIsCreator
            }));
        }
    },
    {
        key: "amount_left",
        label: "Quantity",
        Component: function(param) {
            var amount_left = param.amount_left;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* TextComponent */.Tk, {
                value: amount_left
            });
        }
    },
    {
        key: "price",
        label: "Price",
        Component: function(param) {
            var price = param.price;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* PriceComponent */.C9, {
                value: (0,format/* MutToTez */.QO)(price)
            });
        }
    },
    {
        key: "actions",
        label: "Actions",
        Component: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* ActionOffersComponent */.JR, (0,_object_spread/* default */.Z)({}, props));
        }
    }, 
];
var TableTokenOffers = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Table */.iA, {
        settings: token_offers_settings,
        data: data
    });
};

;// CONCATENATED MODULE: ./src/components/tables/token-swaps/index.tsx






var token_swaps_settings = [
    {
        key: "sellerScreenName",
        label: "From",
        Component: function(param) {
            var sellerScreenName = param.sellerScreenName, seller = param.seller, sellerIsYou = param.sellerIsYou, sellerIsCreator = param.sellerIsCreator;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* UserComponent */.A2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, seller.user[0].user), {
                parsedScreenName: sellerScreenName,
                address: seller.address,
                isYou: sellerIsYou,
                isCreator: sellerIsCreator
            }));
        }
    },
    {
        key: "type",
        label: "Type",
        Component: function(param) {
            var start_price = param.start_price, end_price = param.end_price, ending_time = param.ending_time;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* SwapTypeComponent */.av, {
                start_price: start_price,
                end_price: end_price,
                ending_time: ending_time
            });
        }
    },
    {
        key: "amount_left",
        label: "Quantity",
        Component: function(param) {
            var amount_left = param.amount_left;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* TextComponent */.Tk, {
                value: amount_left
            });
        }
    },
    {
        key: "timestamp",
        label: "Date",
        Component: function(param) {
            var timestamp = param.timestamp;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* DateComponent */.Id, {
                timestamp: timestamp
            });
        }
    },
    {
        key: "ending_time",
        label: "Ending",
        Component: function(param) {
            var ending_time = param.ending_time;
            return ending_time ? /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* DateComponent */.Id, {
                timestamp: ending_time
            }) : null;
        }
    },
    {
        key: "current_price",
        label: "Price",
        Component: function(param) {
            var current_price = param.current_price;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* PriceComponent */.C9, {
                value: (0,format/* MutToTez */.QO)(current_price)
            });
        }
    },
    {
        key: "actions",
        label: "Actions",
        Component: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_components/* ActionSwapsComponent */.Jw, (0,_object_spread/* default */.Z)({}, props));
        }
    }, 
];
var TableTokenSwaps = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Table */.iA, {
        settings: token_swaps_settings,
        data: data
    });
};

;// CONCATENATED MODULE: ./src/components/item-tabs/market.tsx











var Market = function(param) {
    var token = param.token;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    });
    var viewer = (ref = auth.user) === null || ref === void 0 ? void 0 : ref.id;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.token;
    }), holders = ref1.holders, swaps = ref1.swaps, offers = ref1.offers, auctions = ref1.auctions, creators = ref1.creators;
    var token_id = token.token_id, contract = token.contract;
    var viewerOwnedEditions = (0,utils_token/* getViewerEditionsOutsideMarket */.Dk)(viewer, holders);
    var parsedSwaps = swaps.map(function(user) {
        var seller = user.seller;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
            // seller
            sellerScreenName: (0,utils_user/* getScreenName */.GG)(seller.user[0].user.verified_on_chain, seller.user[0].user.screen_name, seller.user[0].user.id, seller.user[0].user.name),
            sellerIsCreator: creators.filter(function(e) {
                return e.wallet.address === seller.address;
            }).length > 0,
            sellerIsYou: seller.address === viewer
        });
    });
    var parsedAuctions = auctions.map(function(user) {
        var seller = user.seller, current_bidder = user.current_bidder;
        return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
            // seller
            sellerScreenName: (0,utils_user/* getScreenName */.GG)(seller.user[0].user.verified_on_chain, seller.user[0].user.screen_name, seller.user[0].user.id, seller.user[0].user.name),
            sellerIsCreator: creators.filter(function(e) {
                return e.wallet.address === seller.address;
            }).length > 0,
            sellerIsYou: seller.address === viewer
        }), current_bidder && {
            bidderScreenName: (0,utils_user/* getScreenName */.GG)(current_bidder.user[0].user.verified_on_chain, current_bidder.user[0].user.screen_name, current_bidder.user[0].user.id, current_bidder.user[0].user.name),
            bidderIsCreator: creators.filter(function(e) {
                return e.wallet.address === current_bidder.user[0].user.id;
            }).length > 0,
            bidderIsYou: current_bidder.user[0].user.id === viewer
        });
    });
    var parsedOffers = offers.map(function(user) {
        var buyer = user.buyer;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
            // buyer
            buyerScreenName: (0,utils_user/* getScreenName */.GG)(buyer.user[0].user.verified_on_chain, buyer.user[0].user.screen_name, buyer.user[0].user.id, buyer.user[0].user.name),
            buyerIsCreator: creators.filter(function(e) {
                return e.wallet.address === buyer.address;
            }).length > 0,
            buyerIsYou: buyer.address === viewer
        });
    });
    var handleCreateSwap = function() {
        var ref;
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "swap-create",
                platformName: contract.name,
                tokenKT: (ref = contract.wallet) === null || ref === void 0 ? void 0 : ref.address,
                tokenId: token_id,
                tokensOwned: viewerOwnedEditions,
                creatorsTotal: token.creators.length
            }
        });
    };
    var handleCreateAuction = function() {
        var ref;
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "auction-create",
                platformName: contract.name,
                tokenKT: (ref = contract.wallet) === null || ref === void 0 ? void 0 : ref.address,
                tokenId: token_id,
                creatorsTotal: token.creators.length
            }
        });
    };
    var handleTransfer = function() {
        var ref;
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "token-transfer",
                platformName: contract.name,
                tokenKT: (ref = contract.wallet) === null || ref === void 0 ? void 0 : ref.address,
                tokenId: token_id,
                tokensOwned: viewerOwnedEditions
            }
        });
    };
    var handleBurn = function() {
        var ref;
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "token-burn",
                platformName: contract.name,
                tokenKT: (ref = contract.wallet) === null || ref === void 0 ? void 0 : ref.address,
                tokenId: token_id,
                tokensOwned: viewerOwnedEditions
            }
        });
    };
    var getCopy = function(quantity) {
        switch(quantity){
            case 1:
                return "You own ".concat(quantity, ' edition of "').concat(token.title, '".');
            default:
                return "You own ".concat(quantity, ' editions of "').concat(token.title, '".');
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
        css: {
            flexDirection: "column",
            minHeight: 256
        },
        children: [
            viewerOwnedEditions > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        css: {
                            color: "$secondaryFill"
                        },
                        children: getCopy(viewerOwnedEditions)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                        css: {
                            marginBottom: "$space$1",
                            "& > *": {
                                marginRight: "$space$4"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "market",
                                onClick: handleCreateSwap,
                                children: "Create Swap"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "market",
                                onClick: handleCreateAuction,
                                children: "Create Auction"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "market",
                                onClick: handleTransfer,
                                children: "Transfer"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                variant: "market",
                                onClick: handleBurn,
                                children: "Burn"
                            })
                        ]
                    })
                ]
            }),
            auctions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    flexDirection: "column",
                    marginBottom: "$space$1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        as: "h6",
                        children: "Auctions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableTokenAuctions, {
                        data: parsedAuctions
                    })
                ]
            }),
            swaps.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    flexDirection: "column",
                    marginBottom: "$space$1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        as: "h6",
                        children: "Swaps"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableTokenSwaps, {
                        data: parsedSwaps
                    })
                ]
            }),
            offers.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    flexDirection: "column",
                    marginBottom: "$space$1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        as: "h6",
                        children: "Offers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableTokenOffers, {
                        data: parsedOffers
                    })
                ]
            }),
            viewerOwnedEditions === 0 && swaps.length === 0 && auctions.length === 0 && offers.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                css: {
                    color: "$secondaryFill"
                },
                children: "This token is not for sale."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/item-tabs/styles.ts

var item_tabs_styles_Container = (0,stitches/* styled */.zo)("div", {});
var List = (0,stitches/* styled */.zo)("div", {
    flexShrink: 0,
    display: "flex",
    borderBottom: "1px solid $colors$primaryBorder",
    overflowX: "auto"
});
var Tabs = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column"
});
var Trigger = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    padding: "10px 20px",
    color: "$secondaryFill",
    userSelect: "none",
    cursor: "pointer",
    "&:focus": {
        outline: 0
    },
    "&:hover": {
        color: "$primaryFill"
    },
    '&[data-state="active"]': {
        color: "$primaryFill",
        boxShadow: "inset 0 -1px 0 0 currentColor, 0 1px 0 0 currentColor"
    }
});
var Quantity = (0,stitches/* styled */.zo)("div", {
    color: "$secondaryFill",
    marginLeft: 8,
    fontSize: 10
});
var Content = (0,stitches/* styled */.zo)("div", {
    flexGrow: 1,
    padding: "$space$2 0 $space$1 0",
    "&:focus": {
        outline: 0
    }
});

;// CONCATENATED MODULE: ./src/components/item-tabs/index.tsx










var ItemTabs = function(param) {
    var token = param.token;
    var t = (0,use_intl_esm3/* default */.Z)("token");
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.token;
    }), holders = ref.holders, swaps = ref.swaps, auctions = ref.auctions, offers = ref.offers;
    // market total
    var total = swaps.length + auctions.length + offers.length;
    var data = [
        {
            key: "info",
            label: t("info"),
            count: 0,
            Component: Info
        },
        {
            key: "collectors",
            label: t("collectors"),
            count: holders.length,
            Component: Collectors
        },
        {
            key: "history",
            label: t("history"),
            count: 0,
            Component: History
        },
        {
            key: "market",
            label: t("market"),
            count: total,
            Component: Market
        }, 
    ];
    var ref1 = (0,react.useState)(data[0].key), focused = ref1[0], setFocused = ref1[1];
    var handleTabFocus = function(focusId) {
        setFocused(focusId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(item_tabs_styles_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Root */.fC, {
            asChild: true,
            defaultValue: focused,
            onValueChange: handleTabFocus,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* List */.aV, {
                        asChild: true,
                        "aria-label": "tabs item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                            children: data.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Trigger */.xz, {
                                    asChild: true,
                                    value: item.key,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trigger, {
                                        children: [
                                            item.label,
                                            " ",
                                            item.count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity, {
                                                children: item.count
                                            })
                                        ]
                                    })
                                }, item.key);
                            })
                        })
                    }),
                    data.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Content */.VY, {
                            asChild: true,
                            value: item.key,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                children: focused === item.key && /*#__PURE__*/ (0,jsx_runtime.jsx)(item.Component, {
                                    token: token
                                })
                            })
                        }, item.key);
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var dist_index_es = __webpack_require__(98130);
;// CONCATENATED MODULE: ./src/components/bidding-countdown/styles.ts

var bidding_countdown_styles_Container = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    border: "1px solid $colors$primaryBorder",
    borderRadius: 5,
    padding: 8,
    marginBottom: "$space$4",
    justifyContent: "space-between"
});

;// CONCATENATED MODULE: ./src/components/bidding-countdown/index.tsx








var BiddingCountDown = function(param) {
    var currentBid = param.currentBid, auctionEnd = param.auctionEnd, isMinBid = param.isMinBid, _simple = param.simple, simple = _simple === void 0 ? false : _simple;
    var t = (0,use_intl_esm3/* default */.Z)("market");
    var tezos = (0,es/* useSelector */.v9)(function(state) {
        return state.global;
    }).tezos;
    var general = (0,es/* useSelector */.v9)(function(state) {
        return state.settings;
    }).general;
    var locale = (0,next_router.useRouter)().locale;
    var renderer = function(props) {
        var formatted = props.formatted, completed = props.completed;
        var days = formatted.days, hours = formatted.hours, minutes = formatted.minutes, seconds = formatted.seconds;
        if (completed) {
            // TODO: decide what to do when bidding finish
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                css: {
                    color: "$secondaryFill"
                },
                children: t("auction-end")
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
            css: {
                display: "flex",
                "& > *": {
                    marginRight: 8
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        width: 50
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            horizontal: true,
                            css: {
                                fontSize: 24
                            },
                            children: days
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            horizontal: true,
                            css: {
                                color: "$secondaryFill",
                                fontSize: 12
                            },
                            children: t("days")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        width: 50
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            horizontal: true,
                            css: {
                                fontSize: 24
                            },
                            children: hours
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            horizontal: true,
                            css: {
                                color: "$secondaryFill",
                                fontSize: 12
                            },
                            children: t("hours")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        width: 50
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            horizontal: true,
                            css: {
                                fontSize: 24
                            },
                            children: minutes
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            horizontal: true,
                            css: {
                                color: "$secondaryFill",
                                fontSize: 12
                            },
                            children: t("minutes")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        width: 50
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            horizontal: true,
                            css: {
                                fontSize: 24
                            },
                            children: seconds
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            horizontal: true,
                            css: {
                                color: "$secondaryFill",
                                fontSize: 12
                            },
                            children: t("seconds")
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(bidding_countdown_styles_Container, {
        children: [
            !simple && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                css: {
                    display: "flex",
                    flexDirection: "column"
                },
                children: isMinBid ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                            css: {
                                color: "$secondaryFill",
                                marginBottom: "$space$5",
                                fontSize: 12
                            },
                            children: [
                                t("no-bids"),
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tooltip */.u, {
                                    description: "No bids have been placed on this auction",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        children: "help"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                            css: {
                                color: "$primaryFill",
                                marginBottom: "$space$5",
                                fontSize: 12
                            },
                            children: [
                                "Reserve ",
                                currentBid,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tezos */.Qo, {})
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                            css: {
                                color: "$secondaryFill",
                                marginBottom: "$space$5",
                                fontSize: 12
                            },
                            children: [
                                "Current bid\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tooltip */.u, {
                                    description: "Fiat value is for reference purposes only. The live Tezos price is currently ".concat((0,format/* getFiat */.m5)(general.currency, tezos, locale), ", and is updated every five minutes."),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        children: "help"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                fontSize: 24
                            },
                            children: [
                                currentBid,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tezos */.Qo, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                            css: {
                                color: "$secondaryFill",
                                margin: "$space$5 0",
                                fontSize: 12
                            },
                            children: (0,format/* getFiat */.m5)(general.currency, currentBid * tezos, locale)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    display: "flex",
                    flexDirection: "column"
                },
                children: [
                    !simple && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        css: {
                            color: "$secondaryFill",
                            marginBottom: "$space$5",
                            fontSize: 12
                        },
                        children: t("auction-ending")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* default */.ZP, {
                        date: auctionEnd,
                        renderer: renderer,
                        onComplete: function() {
                        // TODO: bidding ended. Do something
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/purchase/bid/index.tsx








var Bid = function(param) {
    var auction_id = param.auction_id, current_bid = param.current_bid, end_time = param.end_time, current_bidder = param.current_bidder;
    var t = (0,use_intl_esm3/* default */.Z)("market");
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleAuctionBid = function() {
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "auction-bid",
                auctionId: auction_id,
                currentBid: current_bid,
                isMinBid: current_bidder === null
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BiddingCountDown, {
                currentBid: (0,format/* MutToTez */.QO)(current_bid),
                auctionEnd: new Date(end_time).getTime(),
                isMinBid: current_bidder === null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
                onClick: handleAuctionBid,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    full: true,
                    variant: "primary",
                    children: t("bid")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/lib/beacon.ts + 211 modules
var beacon = __webpack_require__(91435);
// EXTERNAL MODULE: ./src/utils/node.ts
var node = __webpack_require__(49503);
;// CONCATENATED MODULE: ./src/components/purchase/collect/index.tsx










var Collect = function(param) {
    var swap_id = param.swap_id, start_price = param.start_price, end_price = param.end_price, amount = param.amount, amount_left = param.amount_left, current_price = param.current_price, token = param.token;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isAdvanced = start_price !== end_price;
    var handleCollect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isAdvanced) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            dispatch({
                                type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
                                payload: {
                                    type: "swap-slippage",
                                    swapId: swap_id,
                                    startPrice: start_price,
                                    endPrice: end_price,
                                    amount: amount,
                                    amountLeft: amount_left,
                                    creatorsTotal: token.creators.length
                                }
                            });
                        }
                        _ctx.next = 7;
                        break;
                    case 4:
                        _ctx.next = 6;
                        return (0,node/* testNodeHealth */.M)();
                    case 6:
                        (0,beacon/* swapCollect */.RF)(swap_id, current_price, 1, token.creators.length);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCollect() {
            return _ref.apply(this, arguments);
        };
    }();
    // if isAdvanced we need to fire a new modal
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
        onClick: handleCollect,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Button */.zx, {
            full: true,
            variant: "primary",
            children: [
                "Collect for ".concat((0,format/* MutToTez */.QO)(current_price)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tezos */.Qo, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/purchase/offer/index.tsx






var Offer = function(param) {
    var tokenKT = param.tokenKT, tokenId = param.tokenId;
    var t = (0,use_intl_esm3/* default */.Z)("market");
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleCreateOffer = function() {
        dispatch({
            type: modals/* actions.MODALS_SET_MODAL */.Nw.MODALS_SET_MODAL,
            payload: {
                type: "offer-create",
                tokenKT: tokenKT,
                tokenId: tokenId
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_decorator/* AuthDecorator */.X, {
        onClick: handleCreateOffer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
            full: true,
            variant: "secondary",
            children: t("offer")
        })
    });
};

;// CONCATENATED MODULE: ./src/components/purchase/styles.ts

var purchase_styles_Container = (0,stitches/* styled */.zo)("div", {
    width: "100%",
    "@bp2": {
        width: 350
    }
});

;// CONCATENATED MODULE: ./src/components/purchase/index.tsx








var Purchase = function(param) {
    var token = param.token;
    var ref;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.token;
    }), auction = ref1.auction, swap /* , creator_swap */  = ref1.swap;
    var contract = token.contract, token_id = token.token_id;
    var prioritiseRender = function() {
        // if (creator_swap) {
        //   return <Collect {...creator_swap} />;
        // }
        if (swap) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collect, (0,_object_spread/* default */.Z)({}, swap));
        }
        if (auction) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bid, (0,_object_spread/* default */.Z)({}, auction));
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(purchase_styles_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
            css: {
                flexDirection: "column",
                "& > *": {
                    marginBottom: "$space$4"
                }
            },
            children: [
                prioritiseRender(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Offer, {
                    tokenKT: (ref = contract.wallet) === null || ref === void 0 ? void 0 : ref.address,
                    tokenId: token_id
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/state/token/index.ts
var state_token = __webpack_require__(93353);
;// CONCATENATED MODULE: ./src/utils/fullscreen.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ // export const requestFullscreen = (element?: any) => {
//   const el = element || document.body;
//   // Supports most browsers and their versions.
//   const requestMethod =
//     el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen;
//   if (requestMethod) {
//     requestMethod.call(el);
//   } else if (typeof window.ActiveXObject !== 'undefined') {
//     // Older IE.
//     const wscript = new window.ActiveXObject('WScript.Shell');
//     if (wscript !== null) {
//       wscript.SendKeys('{F11}');
//     }
//   }
// };
var toggleFullScreen = function(element) {
    var el = element || document.documentElement;
    if (!document.fullscreenElement) {
        el.requestFullscreen();
    } else if (document.exitFullscreen) {
        document.exitFullscreen();
    }
};

;// CONCATENATED MODULE: ./src/containers/container-token/styles.ts

var container_token_styles_Container = (0,stitches/* styled */.zo)("div", {
    position: "relative",
    display: "flex",
    flexDirection: "column"
});
var Media = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    "@bp1": {
        alignItems: "center",
        height: "calc(var(--app-height) - 64px - $space$1)"
    },
    "&:fullscreen": {
        height: "var(--app-height)",
        "&>*:first-child": {
            maxHeight: "var(--app-height)!important"
        }
    }
});
var styles_Info = (0,stitches/* styled */.zo)("div", {
    width: "100%",
    zIndex: 1,
    "@bp1": {
        width: "calc(100% - 350px - 64px)",
        marginRight: "$space$1"
    }
});
var styles_Purchase = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    width: "100%",
    "@bp1": {
        paddingTop: 41,
        width: 350
    }
});

;// CONCATENATED MODULE: ./src/containers/container-token/titles/styles.ts

var SmallTitle = (0,stitches/* styled */.zo)("div", {
    position: "fixed",
    left: 0,
    bottom: 0,
    width: "100vw",
    height: "$space$1",
    // zIndex: -1,
    opacity: 1,
    transition: "opacity 0.2s ease-in-out",
    display: "none",
    "@bp1": {
        padding: "0 $space$2",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row"
    },
    "@bp2": {
        padding: "0 $space$1"
    },
    variants: {
        faded: {
            true: {
                opacity: 0,
                pointerEvents: "none"
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/containers/container-token/titles/index.tsx




var Titles = function(param) {
    var inView = param.inView, title = param.title, creators = param.creators, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallTitle, {
        faded: inView,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                vertical: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        unset: true,
                        ellipsis: true,
                        css: {
                            fontWeight: 700,
                            overflow: "hidden",
                            marginRight: "$space$4"
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_creators/* Creators */.y, {
                        creators: creators
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                vertical: true,
                css: {
                    "&>*": {
                        marginLeft: "$4"
                    }
                },
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/containers/container-token/index.tsx

/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable react/no-array-index-key */ /* eslint-disable react-hooks/exhaustive-deps */ 




















var MediaWrapper = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4824), __webpack_require__.e(9645), __webpack_require__.e(9943), __webpack_require__.e(2278)]).then(__webpack_require__.bind(__webpack_require__, 33754));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33754)
            ];
        }
    },
    ssr: false
});
var ItemSignCollaboration = dynamic_default()(__webpack_require__.e(/* import() */ 9217).then(__webpack_require__.bind(__webpack_require__, 19217)).then(function(e) {
    return e.ItemSignCollaboration;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19217)
            ];
        }
    },
    ssr: false
});
var ContainerToken = function(param) {
    var token = param.token;
    var ref, ref1;
    var domElement = (0,react.useRef)(null);
    var t = (0,use_intl_esm3/* default */.Z)("token");
    var dispatch = (0,es/* useDispatch */.I0)();
    var locale = (0,next_router.useRouter)().locale;
    var ref2 = (0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 0.001
    }), ref3 = ref2.ref, inView = ref2.inView;
    (0,react.useEffect)(function() {
        dispatch({
            type: state_token/* actions.TOKEN_UPDATE_TOKEN */.Nw.TOKEN_UPDATE_TOKEN,
            payload: {
                id: token.id,
                creators: token.creators
            }
        });
    }, [
        token.id
    ]);
    var getLicenseFromKey = function(key) {
        switch(key){
            case "custom":
                return "Custom License";
            case "public":
                return "Public Domain";
            default:
                return key;
        }
    };
    var flashing = ((ref = token.accessibility) === null || ref === void 0 ? void 0 : ref.hazards) ? ((ref1 = token.accessibility) === null || ref1 === void 0 ? void 0 : ref1.hazards.indexOf("flashing")) !== -1 : false;
    var explicit = token.nsfw;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container_token_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                ref: domElement,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaWrapper, {
                    token: token,
                    labels: false,
                    inDetailView: true
                }, token.id)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Container */.W2, {
                css: {
                    display: "none",
                    "@bp1": {
                        display: "flex"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Titles, {
                    inView: inView,
                    title: token.title,
                    creators: token.creators,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                i: {
                                    fontSize: 16,
                                    marginLeft: "$4"
                                }
                            },
                            children: [
                                flashing && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tooltip */.u, {
                                    description: "Photosensitive seizure warning",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        children: "bolt"
                                    })
                                }),
                                explicit && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Tooltip */.u, {
                                    description: "Explicit content",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        children: "explicit"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                            variant: "basic",
                            onClick: function() {
                                return toggleFullScreen(domElement.current);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                children: "fullscreen"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Container */.W2, {
                css: {
                    height: 64,
                    "@bp1": {
                        display: "none"
                    },
                    display: "flex",
                    "&>*": {
                        marginRight: "$3",
                        i: {
                            width: 24
                        }
                    }
                },
                children: [
                    flashing && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                        css: {
                            height: "100%",
                            i: {
                                fontSize: 16
                            },
                            "@bp1": {
                                display: "none"
                            }
                        },
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                children: "bolt"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                unset: true,
                                css: {
                                    fontSize: 14,
                                    color: "$secondaryFill"
                                },
                                children: "Photosensitive seizure warning"
                            })
                        ]
                    }),
                    explicit && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                        css: {
                            height: "100%",
                            i: {
                                fontSize: 16
                            },
                            "@bp1": {
                                display: "none"
                            }
                        },
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                children: "explicit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                unset: true,
                                css: {
                                    fontSize: 14,
                                    color: "$secondaryFill"
                                },
                                children: "Explicit content"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: ref3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Container */.W2, {
                        css: {
                            display: "flex",
                            flexDirection: "column",
                            marginBottom: "$space$1",
                            "@bp1": {
                                flexDirection: "unset"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                css: {
                                    flexDirection: "column",
                                    lineBreak: "auto",
                                    overflow: "hidden",
                                    width: "100%",
                                    "@bp1": {
                                        width: "calc(100% - $space$2 -  350px)",
                                        marginRight: "$space$2"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSignCollaboration, {
                                        tokenId: token.token_id
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                        css: {
                                            padding: "$space$5 0"
                                        },
                                        vertical: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_creators/* Creators */.y, {
                                            creators: token.creators,
                                            avatar: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                        as: "h3",
                                        unset: true,
                                        children: token.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                        vertical: true,
                                        css: {
                                            marginBottom: "$space$2",
                                            padding: "$space$4 0",
                                            "&>*": {
                                                marginRight: "$space$4"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLike, {
                                                tokenId: token.id
                                            }, token.id),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSave, {
                                                tokenId: token.id
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                        css: {
                                            flexDirection: "column",
                                            marginBottom: "$space$2"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                            unset: true,
                                            css: {
                                                color: "$secondaryFill",
                                                maxWidth: 1024,
                                                whiteSpace: "pre-wrap",
                                                lineBreak: "auto",
                                                overflow: "hidden"
                                            },
                                            children: token.description
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                        css: {
                                            marginBottom: "$space$2"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                            css: {
                                                flexFlow: "row wrap",
                                                display: "flex",
                                                "& > *": {
                                                    marginRight: 8,
                                                    marginBottom: 8
                                                }
                                            },
                                            children: token.tags.map(function(param) {
                                                var tag = param.tag;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/explore?tags=".concat(tag.id),
                                                    locale: locale,
                                                    prefetch: false,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                                        variant: "tag",
                                                        as: "a",
                                                        children: tag.name
                                                    })
                                                }, tag.id);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                        css: {
                                            flexDirection: "column",
                                            marginBottom: "$space$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                                css: {
                                                    fontWeight: 700,
                                                    marginBottom: "$space$5"
                                                },
                                                children: t("editions", {
                                                    edition: token.supply
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                                                unset: true,
                                                css: {
                                                    color: "$secondaryFill",
                                                    fontStyle: "italic",
                                                    fontSize: 14
                                                },
                                                children: [
                                                    "Medium: ",
                                                    (0,utils_token/* extractMedium */.Id)(token),
                                                    ". Minted on:",
                                                    " ",
                                                    new Date(token.timestamp).toLocaleDateString(locale, constants/* DATE_OPTIONS */.AW),
                                                    ".",
                                                    " ",
                                                    token.rights !== "none" && token.right_uri !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            "Artwork released under\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                                                as: "a",
                                                                variant: "underline",
                                                                href: (0,ipfs/* getURLFromIPFSURI */.vR)(token.right_uri),
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                children: getLicenseFromKey(token.rights)
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                css: {
                                    width: "100%",
                                    margin: "$space$2 0",
                                    "@bp1": {
                                        width: 350,
                                        margin: "unset"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Purchase, {
                                    token: token
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Container */.W2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTabs, {
                            token: token
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Container */.W2, {
                        css: {
                            marginBottom: "$space$1"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CuratedOn, {
                            id: token.id
                        })
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);